import { render } from "./CLayerStockInput.vue?vue&type=template&id=56194509"
import script from "./CLayerStockInput.vue?vue&type=script&lang=js"
export * from "./CLayerStockInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__